import React from "react";
import "./TopHomeSection.scss";
import "../../assets/css/Animation.scss";

function TopHomeSection() {
  return (
    <div className="top-section">
      <div className="container">
        <div className=" top-content">
          <div className="logo-back">
            <img
              width={360}
              className="fadeInUp"
              src={process.env.REACT_APP_LOGO}
              alt="right-icon"
            />
          </div>
          <h1 className="top-content__title fadeInLeft">
            Ekspresikan Logomu <br />
            Lebih Hidup Lebih Profesional
          </h1>
          <h5 className="fadeInUp top-content__subtitle">
            Sempurnakan brandmu dengan digital animasi berkelas
            <br />
            Harga yang terjangkau dapatkan hasil yang memukau
          </h5>
          <div className="top-content__image fadeInRight">
            <video
              src="https://goolpy-assets.pages.dev/main.logo.mp4"
              type="video/mp4"
              width="768"
              height="432"
              autoPlay
              muted
              loop
            ></video>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopHomeSection;
